"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _clientStorage = require("../clientStorage");

var _getAuthStateKeys = _interopRequireDefault(require("./getAuthStateKeys"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * remove auth state keys from local storage
 */


var removeAuthStateKeysFromLocalStorage = function removeAuthStateKeysFromLocalStorage() {
  (0, _getAuthStateKeys.default)(_clientStorage.CLIENT_STORAGE_LOCAL_STORAGE).forEach(function (key) {
    (0, _clientStorage.removeItem)(key, _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
  });
};
/**
 * remove auth state keys from cookies
 */


var removeAuthStateKeysFromCookies = function removeAuthStateKeysFromCookies() {
  (0, _getAuthStateKeys.default)(_clientStorage.CLIENT_STORAGE_COOKIES).forEach(function (key) {
    (0, _clientStorage.removeItem)(key, _clientStorage.CLIENT_STORAGE_COOKIES);
  });
};
/**
 * Remove auth state keys from all supported storage types
 */


var removeAuthStateKeysFromAll = function removeAuthStateKeysFromAll() {
  removeAuthStateKeysFromLocalStorage();
  removeAuthStateKeysFromCookies();
};
/**
 * remove all auth state keys for specified storage type
 */


var removeAuthStateKeys = function removeAuthStateKeys(clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return removeAuthStateKeysFromCookies();

    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return removeAuthStateKeysFromLocalStorage();

    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return removeAuthStateKeysFromAll();
  }
};

var _default = removeAuthStateKeys;
exports.default = _default;